export const DATA_ERROR = 'DATA_ERROR';
export const DATA_LOADING = 'DATA_LOADING';
export const DATA_SUCCESS = 'DATA_SUCCESS';

export const SET_ACTIVE = 'SET_ACTIVE';
export const SET_INACTIVE = 'SET_INACTIVE';

export const RESET = 'RESET';
export const ZOOM_ON_COUNTRY = 'ZOOM_ON_COUNTRY';
export const CHANGE_VIEWPORT = 'CHANGE_VIEWPORT';

export const NHS_DATA_ERROR = 'NHS_DATA_ERROR';
export const NHS_DATA_LOADING = 'NHS_DATA_LOADING';
export const NHS_DATA_SUCCESS = 'NHS_DATA_SUCCESS';

export const NEWS_DATA_ERROR = 'NEWS_DATA_ERROR';
export const NEWS_DATA_LOADING = 'NEWS_DATA_LOADING';
export const NEWS_DATA_SUCCESS = 'NEWS_DATA_SUCCESS';


export const COUNTRIES_DATA_SORT = 'COUNTRIES_DATA_SORT';
export const COUNTRIES_DATA_ERROR = 'COUNTRIES_DATA_ERROR';
export const COUNTRIES_DATA_LOADING = 'COUNTRIES_DATA_LOADING';
export const COUNTRIES_DATA_SUCCESS = 'COUNTRIES_DATA_SUCCESS';

export const HISTORICAL_DATA_ERROR = 'HISTORICAL_DATA_ERROR';
export const HISTORICAL_DATA_LOADING = 'HISTORICAL_DATA_LOADING';
export const HISTORICAL_DATA_SUCCESS = 'HISTORICAL_DATA_SUCCESS';
export const HISTORICAL_URL_ENDPOINT_UPDATE = 'HISTORICAL_URL_ENDPOINT_UPDATE';
export const HISTORICAL_COUNTRY_DATA_LOADING = 'HISTORICAL_COUNTRY_DATA_LOADING';
